import { render, staticRenderFns } from "./mainOrder.vue?vue&type=template&id=6f3e667e&scoped=true&"
import script from "./mainOrder.vue?vue&type=script&lang=js&"
export * from "./mainOrder.vue?vue&type=script&lang=js&"
import style0 from "./mainOrder.vue?vue&type=style&index=0&id=6f3e667e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3e667e",
  null
  
)

export default component.exports